module.exports = __webpack_public_path__ + "img/0d91bf6.png";